import { render, staticRenderFns } from "./ThresholdSampling.vue?vue&type=template&id=5e6df27a&scoped=true&"
import script from "./ThresholdSampling.vue?vue&type=script&lang=js&"
export * from "./ThresholdSampling.vue?vue&type=script&lang=js&"
import style0 from "./ThresholdSampling.vue?vue&type=style&index=0&id=5e6df27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6df27a",
  null
  
)

/* custom blocks */
import block0 from "./ThresholdSampling.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports